import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class IntelligentHomeHead extends Component {
  render() {
    const { open, schoolFilter, handleSwitchYear, handleVisibleAdvanceModal } =
      this.props;
    return (
      <div className="intelligentHomeHead_box">
        <div className="intelligentHomeHead_year_box fl">
          <div
            onClick={() => handleSwitchYear(2026)}
            className={
              schoolFilter.year === 2026
                ? "intelligentHomeHead_year_item_box_active fl"
                : "intelligentHomeHead_year_item_box fl"
            }
          >
            2026
          </div>
          <div
            onClick={() => handleSwitchYear(2025)}
            className={
              schoolFilter.year === 2025
                ? "intelligentHomeHead_year_item_box_active fl"
                : "intelligentHomeHead_year_item_box fl"
            }
          >
            2025
          </div>
          <div
            onClick={() => handleSwitchYear(2024)}
            className={
              schoolFilter.year === 2024
                ? "intelligentHomeHead_year_item_box_active fl"
                : "intelligentHomeHead_year_item_box fl"
            }
          >
            2024
          </div>
          {/* <div*/}
          {/*  onClick={() => handleSwitchYear(2023)}*/}
          {/*  className={*/}
          {/*    schoolFilter.year === 2023*/}
          {/*      ? "intelligentHomeHead_year_item_box_active fl"*/}
          {/*      : "intelligentHomeHead_year_item_box fl"*/}
          {/*  }*/}
          {/*>*/}
          {/*  2023*/}
          {/*</div>*/}
          {/* <div
            onClick={() => handleSwitchYear(2018)}
            className={
              schoolFilter.year === 2018
                ? "intelligentHomeHead_year_item_box_active fl"
                : "intelligentHomeHead_year_item_box fl"
            }
          >
            2018
          </div> */}
        </div>
        <div
          onClick={() => handleVisibleAdvanceModal()}
          className="intelligentHomeHead_ahead_box fr"
        >
          提前批 >
        </div>
        <div
          onClick={() => open()}
          class="fr intelligentHomeHead_info_box"
          style={{ marginTop: 7 }}
        >
          <div class="fl ">必读</div>
          <div class="trinity_result_header_triangle fr"></div>
        </div>
      </div>
    );
  }
}

export default IntelligentHomeHead;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentHomeHead/index.js